import React from 'react'
import { HashIcon, TopBar } from 'prove-common'
import { useParams } from 'react-router'
import { AppLogo } from '../app-logo/AppLogo'

export const ChangelogScreenTopBar: React.FC = () => {
  const { sampleId } = useParams()
  const breadcrumbItems = [
    {
      label: 'Prøver',
      to: '/samples'
    },
    {
      label: '#' + sampleId,
      to: `/samples/${sampleId}`,
      icon: <HashIcon />
    },
    {
      label: 'Endringslogg'
    }
  ]
  return (
    <TopBar
      breadcrumbItems={breadcrumbItems}
      logo={<AppLogo />}
      showNotificationBell={true}
    />
  )
}
